import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import * as Sentry from '@sentry/browser';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import './api/client-evs';
import { App } from './App';
import { LanguageContextProvider } from './LanguageContext';
import { ReactQueryProvider } from './providers/ReactQueryProvider';
import { SnackbarProvider } from './providers/SnackbarProvider';
import { theme } from './theme';
import TranslationsProvider from './TranslastionsProvider';
import { AuthProvider } from './providers/AuthProvider/AuthContext';
import { ConfigProvider } from './providers/ConfigProvider/ConfigContext';

Sentry.init({
  dsn: 'https://795dc1c2e7944c8cbe117c85cfddd277@glitchtip-ipsos.commity.cz/11',
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 1.0,
});

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <CssVarsProvider theme={theme}>
    <StrictMode>
      <BrowserRouter>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ReactQueryProvider>
            <SnackbarProvider>
              <ConfigProvider>
                <AuthProvider>
                  <LanguageContextProvider>
                    <TranslationsProvider>
                      <App />
                    </TranslationsProvider>
                  </LanguageContextProvider>
                </AuthProvider>
              </ConfigProvider>
            </SnackbarProvider>
            {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
          </ReactQueryProvider>
        </LocalizationProvider>
      </BrowserRouter>
    </StrictMode>
  </CssVarsProvider>
);
